import builder from '../builder';
import TaskListCash from '../../streamline-icons/bold/task-list-cash.svg';

export default builder('IconTaskListCashBold', TaskListCash);
